<template>
    <!-- 对话框 -->
    <el-drawer
        title="编辑订单模式"
        :visible.sync="show"
        :before-close="closeDialog"
        :with-header="false"
        size="70%"
        class="order-model-wrap"
    >
        <div style="display: flex; justify-content: flex-end; padding: 20px 20px 0">
            <el-button @click="addContent" type="success" style="width: 50px; height: 40px" icon="el-icon-plus"></el-button>
        </div>

        <!-- 基本信息表单 -->
        <div class="form-box" style="height: 80vh; overflow-y: auto; margin-top: 20px" v-loading="loading">
            <el-form label-width="80px">
                <el-form-item label="模式名称" label-width="180px">
                    <el-input v-model="submit_data.name" style="width: 150px"></el-input>
                </el-form-item>
                <el-form-item label="选择端口" label-width="180px">
                    <!-- 下拉选择端口 -->
                    <el-select v-model="value_port" placeholder="请选择端口" style="width: 150px" @change="portChange" clearable>
                        <el-option label="司机" value="driver"></el-option>
                        <el-option label="乘客" value="consumer"></el-option>
                        <el-option label="第三方" value="openApi"></el-option>
                        <el-option label="全部" value="all"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="模式扣款金额（元）" label-width="180px">
                    <div style="display: flex; align-items: center">
                        <el-input
                            v-model="submit_data.kilometer_mode_deduction"
                            style="width: 150px; margin-right: 10px"
                            placeholder="固定金额"
                        >
                        </el-input>
                        <el-tooltip class="item" effect="dark" content="扣司机余额" placement="right">
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </div>
                </el-form-item>
                <el-form-item label="模式扣款比例（%）" label-width="180px">
                    <div style="display: flex; align-items: center">
                        <el-input
                            v-model="submit_data.kilometer_mode_deduction_ratio"
                            style="width: 150px; margin-right: 10px"
                            placeholder="按比例(%)"
                        >
                        </el-input>
                        <el-tooltip class="item" effect="dark" content="扣司机余额" placement="right">
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </div>
                </el-form-item>

                <el-form-item label="恶劣天气模式" label-width="180px">
                    <el-switch v-model="submit_data.is_sleet" active-value="1" inactive-value="0"></el-switch>
                </el-form-item>

                <el-form-item label="合作模式" label-width="180px">
                    <el-switch v-model="submit_data.partner_mode" active-value="1" inactive-value="0"></el-switch>
                </el-form-item>

                <!-- <el-form-item label="扫码指定模式" label-width="180px">
                    <el-switch v-model="submit_data.scan_appoint_order" active-text="" inactive-text="" active-value="1" inactive-value="0">
                    </el-switch>
                </el-form-item> -->

                <el-form-item label="趴单模式" label-width="180px">
                    <el-switch v-model="submit_data.wait_mode" active-value="1" inactive-value="0"></el-switch>
                </el-form-item>

                <el-form-item label="纯公里模式" label-width="180px">
                    <el-switch v-model="submit_data.kilometer_mode" active-value="1" inactive-value="0"></el-switch>
                </el-form-item>
                <el-form-item label="封顶模式" label-width="180px">
                    <el-switch v-model="submit_data.circle_mode" active-value="1" inactive-value="0"> </el-switch>
                </el-form-item>

                <el-form-item label="城市" label-width="180px" v-if="btnType == 'edit'">
                    <el-input placeholder="请输入内容" v-model="value_city_code" disabled style="width: 150px; margin-right: 20px">
                    </el-input>
                </el-form-item>

                <el-form-item label="模式开关" label-width="180px" v-if="btnType == 'edit'">
                    <el-switch v-model="submit_data.status" active-value="1" inactive-value="0"></el-switch>
                </el-form-item>

                <div v-for="(item, index) in spare_data" :key="index" class="box-content">
                    <div style="display: flex; justify-content: flex-end">
                        <el-button type="danger" @click="delData(index)" icon="el-icon-close"></el-button>
                    </div>

                    <!-- 选择时间 -->
                    <div class="box-time">
                        <el-form-item label="开始时间" label-width="180px">
                            <el-time-picker
                                v-model="spare_data[index].time_start"
                                :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                                placeholder="开始时间"
                                @change="timeChange($event, 'time_start')"
                                value-format="HHmm"
                                format="HH:mm"
                            >
                            </el-time-picker>
                        </el-form-item>

                        <el-form-item label="结束时间" label-width="180px">
                            <el-time-picker
                                v-model="spare_data[index].time_end"
                                :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                                placeholder="结束时间"
                                @change="timeChange($event, 'time_end')"
                                value-format="HHmm"
                                format="HH:mm"
                            >
                            </el-time-picker>
                        </el-form-item>
                    </div>

                    <div style="display: flex; justify-content: space-around">
                        <el-form-item :label="obtain_data.short_distance_mode.name" label-width="250px" style="margin-bottom: 40px">
                            <el-switch
                                v-model="spare_data[index].short_distance_mode"
                                placeholder="请选择"
                                @change="select(index, 'short_distance')"
                                style="width: 150px"
                                active-value="1"
                                inactive-value="0"
                            >
                            </el-switch>
                        </el-form-item>
                        <!-- 一口价 -->
                        <el-form-item :label="obtain_data.kilometer_time_mode.name" label-width="250px" style="margin-bottom: 40px">
                            <el-switch
                                v-model="spare_data[index].kilometer_time_mode"
                                placeholder="请选择"
                                @change="select(index, 'kilometer_time_mode')"
                                style="width: 150px"
                                active-value="1"
                                inactive-value="0"
                            >
                            </el-switch>
                        </el-form-item>
                    </div>

                    <div style="display: flex; justify-content: space-around">
                        <el-form-item :label="obtain_data.two_way_charge.name" label-width="250px" style="margin-bottom: 40px">
                            <el-switch
                                v-model="spare_data[index].two_way_charge"
                                placeholder="请选择"
                                @change="select"
                                style="width: 150px"
                                active-value="1"
                                inactive-value="0"
                            >
                            </el-switch>
                        </el-form-item>

                        <!--阶梯计费开关-->
                        <el-form-item
                            v-if="submit_data.kilometer_mode == '1'"
                            :label="obtain_data.kilo_step.name"
                            label-width="250px"
                            style="margin-bottom: 40px"
                        >
                            <el-switch
                                v-model="spare_data[index].kilo_step_mode"
                                placeholder="请选择"
                                @change="kiloStepChange(index)"
                                style="width: 150px"
                                active-value="1"
                                inactive-value="0"
                            >
                            </el-switch>
                        </el-form-item>

                        <el-form-item v-else></el-form-item>
                    </div>

                    <!-- 一口价 -->
                    <div
                        style="background-color: #fff; border-radius: 10px; padding: 20px; margin-bottom: 10px"
                        v-if="spare_data[index].kilometer_time_mode == '1'"
                    >
                        <p style="text-align: center; color: red">！注意：多条一口价情况下,公里/时间数需从小到大填写</p>
                        <div
                            style="display: flex; justify-content: space-around; margin-bottom: 20px; margin-top: 20px; margin-bottom: 20px"
                        >
                            <div>
                                <span>{{ obtain_data.kilometer_time_select.name }}</span>
                                <el-select
                                    v-model="spare_data[index].kilometer_time_select"
                                    placeholder="请选择状态"
                                    @change="kiloChange(index)"
                                >
                                    <el-option label="公里模式" value="1"> </el-option>
                                    <el-option label="时间模式" value="2"> </el-option>
                                </el-select>
                            </div>
                            <div style="display: flex; justify-content: flex-end; margin-bottom: 20px">
                                <!--    添加按钮      -->
                                <el-button
                                    @click="addKilo(index)"
                                    type="success"
                                    style="width: 50px; height: 40px"
                                    icon="el-icon-plus"
                                ></el-button>

                                <!--     删除按钮     -->
                                <el-button
                                    @click="subKilo(index)"
                                    type="danger"
                                    style="width: 50px; height: 40px"
                                    icon="el-icon-minus"
                                ></el-button>
                            </div>
                        </div>

                        <div
                            v-if="spare_data[index].kilometer_time_select == '1'"
                            style="display: flex; justify-content: space-around"
                            v-for="(item2, index2) in spare_data[index].kilo"
                            :key="index2"
                        >
                            <el-form-item label="公里数" label-width="180px">
                                <el-input v-model="item2.kilometer" @input="onInput()" style="width: 120px"> </el-input>
                            </el-form-item>
                            <el-form-item label="金额" label-width="180px">
                                <el-input v-model="item2.kiloprice" @input="onInput()" style="width: 120px"> </el-input>
                            </el-form-item>
                        </div>
                        <div
                            v-if="spare_data[index].kilometer_time_select == '2'"
                            style="display: flex; justify-content: space-around"
                            v-for="(item3, index3) in spare_data[index].kilo_time"
                            :key="index3"
                        >
                            <el-form-item label="分钟" label-width="180px">
                                <el-input v-model="item3.kilotime" @input="onInput()" style="width: 120px"> </el-input>
                            </el-form-item>
                            <el-form-item label="金额" label-width="180px">
                                <el-input v-model="item3.kilotimeprice" @input="onInput()" style="width: 120px"> </el-input>
                            </el-form-item>
                        </div>
                    </div>

                    <!-- 恶劣天气加价 -->

                    <div class="box-body" v-if="submit_data.is_sleet == 1">
                        <el-form-item label="恶劣天气加价(元)" label-width="180px">
                            <el-input v-model="spare_data[index].bad_weather_amount" placeholder="固定金额加价"> </el-input
                        ></el-form-item>

                        <el-form-item label="恶劣天气加价(%)" label-width="180px">
                            <el-input v-model="spare_data[index].bad_weather_rate" placeholder="百分比加价"> </el-input
                        ></el-form-item>
                    </div>

                    <!--阶梯计费设置-->
                    <div
                        style="background-color: #fff; border-radius: 10px; padding: 20px 0 0 0; margin-bottom: 10px"
                        v-if="spare_data[index].kilo_step_mode == '1' && submit_data.kilometer_mode == '1'"
                    >
                        <div style="display: flex; justify-content: space-around">
                            <el-form-item label="超出公里数" label-width="200px">
                                <el-input
                                    v-model="spare_data[index].kilo_step[0].kilo_step_kilometer"
                                    @input="onInput()"
                                    style="width: 120px"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="每公里单价" label-width="180px">
                                <el-input
                                    v-model="spare_data[index].kilo_step[0].kilo_step_kiloprice"
                                    @input="onInput()"
                                    style="width: 120px"
                                ></el-input>
                            </el-form-item>
                        </div>
                    </div>

                    <div class="box-body">
                        <el-form-item
                            :label="item2.name"
                            label-width="180px"
                            v-for="(item2, index2) in obtain_data"
                            :key="index2"
                            v-show="item2.type != 'string' && item2.type != 'select'"
                        >
                            <el-input v-model="spare_data[index][index2]"></el-input>
                        </el-form-item>

                        <el-form-item></el-form-item>
                    </div>
                </div>
            </el-form>
        </div>
        <div style="display: flex; justify-content: center; margin-top: 10px">
            <el-button type="primary" @click="drivingModelOnSubmit" style="width: 80px; height: 40px">保存</el-button>
            <el-button @click="closeDialog" style="width: 80px; height: 40px">关闭</el-button>
        </div>
    </el-drawer>
</template>

<script>
var _this;
export default {
    props: {
        isShow: Boolean,
        data: '',
        drivingModel_select: Object,
        btnType: '' // 区分添加和编辑
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            // 添加页面
            if (_this.btnType == 'add') {
                _this.loading = false;
                _this.submit_url = '/order/addOrderModeSubmit';
                _this.submit_data = {
                    city_code: JSON.parse(localStorage.getItem('login')).city.city_code,
                    name: '',
                    port: 'all', //九州为0，耿师傅为all
                    partner_mode: '0',
                    wait_mode: '0',
                    synchronization: '',
                    password: '',
                    check_password: '0',
                    kilometer_mode: '0',
                    circle_mode: '0', //耿师傅专用
                    is_sleet: '0',
                    scan_appoint_order: '0',
                    kilometer_mode_deduction: '',
                    // kilometer_mode_deduction_type: '',
                    kilometer_mode_deduction_ratio: '',
                    kilo_take_mode: '1', //耿师傅专用
                    kilo_take_type: '1', //耿师傅专用
                    kilo_take: '', //耿师傅专用
                    trip_start_upload_status: '1',
                    trip_end_upload_status: '1'
                    // send_plate: '0',
                    // not_income_wallet: '0'
                };
            } else {
                // 编辑页面
                _this.submit_url = '/order/editOrderModeSubmit';

                _this.submit_data = {
                    city_code: JSON.parse(localStorage.getItem('login')).city.city_code,
                    name: '',
                    port: 'all', //九州为0，耿师傅为all
                    partner_mode: '0',
                    wait_mode: '0',
                    synchronization: '',
                    password: '',
                    check_password: '0',
                    kilometer_mode: '0',
                    circle_mode: '0', //耿师傅专用
                    is_sleet: '0',
                    scan_appoint_order: '0',
                    kilometer_mode_deduction: '',
                    // kilometer_mode_deduction_type: '0',
                    kilometer_mode_deduction_ratio: '',
                    kilo_take_mode: '1', //耿师傅专用
                    kilo_take_type: '1', //耿师傅专用
                    kilo_take: '', //耿师傅专用
                    trip_start_upload_status: '1',
                    trip_end_upload_status: '1',
                    status: '0'

                    // send_plate: '0',
                    // not_income_wallet: '0'
                };
                _this.submit_data.order_mode_code = _this.data;
                _this.value_city_code = _this.drivingModel_select.city;
                _this.getOrderModeDetails(); // 获取模式详情
            }

            // 获取模式规则
            // _this
            //   .$post("/order/getruleMode")
            //   .then((res) => {
            //     // _this.obtain_data = res.data;// 不从接口获取数据，这样，添加新的项目，就不需要接口添加了
            //   })
            //   .catch((err) => {});

            _this.obtain_data = {
                circle_out_kilometre_price: {
                    name: '圈外超出距离(元 / 公里)',
                    type: 'float'
                },
                circle_top: {
                    name: '圈内封顶价格',
                    type: 'int'
                },
                circle_top_amount: {
                    name: '圈内封顶金额',
                    type: 'float'
                },
                kilo: {
                    name: '一口价公里模式收费详情',
                    type: 'select'
                },
                kilo_step: {
                    name: '增值公里',
                    type: 'select'
                },
                kilo_step_mode: {
                    name: '增值公里模式',
                    type: 'select'
                },
                kilo_time: {
                    name: '一口价时间模式收费详情',
                    type: 'select'
                },
                kilometer_time_mode: {
                    name: '一口价',
                    type: 'select'
                },
                kilometer_time_select: {
                    name: '一口价（公里/时间选择）',
                    type: 'select'
                },
                kilometer_top: {
                    name: '封顶公里数',
                    type: 'int'
                },
                limited_time_offer: {
                    name: '优惠费用(此时段优惠)',
                    type: 'int'
                },
                out_free_kilometre_price: {
                    name: '超出距离(元/公里)',
                    type: 'float'
                },
                out_free_time: {
                    name: '超出时长(多少分)',
                    type: 'float'
                },
                out_free_time_price: {
                    name: '超出时长(多少元)',
                    type: 'float'
                },
                out_free_waiting: {
                    name: '超出等待(多少分)',
                    type: 'float'
                },
                out_free_waiting_price: {
                    name: '超出等待(多少元)',
                    type: 'float'
                },
                short_distance_mode: {
                    name: '短途特惠(开关)',
                    type: 'select'
                },
                short_starting_free_kilometre: {
                    name: '短途起步距离(里数)',
                    type: 'int'
                },
                short_starting_free_time: {
                    name: '短途起步时长(分)',
                    type: 'int'
                },
                short_starting_price: {
                    name: '短途起步价',
                    type: 'float'
                },

                starting_free_kilometre: {
                    name: '起步距离(公里数)',
                    type: 'int'
                },
                starting_free_time: {
                    name: '起步时长(分)',
                    type: 'int'
                },
                starting_free_waiting: {
                    name: '免费等待(分)',
                    type: 'int'
                },
                starting_price: {
                    name: '起步价',
                    type: 'float'
                },
                time_end: {
                    name: '结束时间',
                    type: 'string'
                },
                time_start: {
                    name: '开始时间',
                    type: 'string'
                },
                two_way_charge: {
                    name: '双项收费',
                    type: 'select'
                },
                ultra_far_price: {
                    name: '超远附加费(元/次)',
                    type: 'float'
                }
            };
        }
    },
    data() {
        return {
            loading: true,
            show: false,
            submit_url: '',

            // 下拉搜索城市
            value_city_code: '',

            init_time: '',
            // 下拉选择端口
            value_port: 'all',

            // 下拉搜索状态
            value_status_code: '',
            status_select: [],
            // 管理员列表数据
            // admin_lists: [],

            // 下拉搜索模式
            options_mode_code: [],

            selectPages_data: [],
            //获取到的数据
            obtain_data: [],

            // json格式数据
            spare_data: [],

            mode_options_data: {
                page: 1,
                limit: 5
            },

            // 表单数据
            submit_data: {}
        };
    },
    created() {
        _this = this;
    },
    methods: {
        // 详情
        getOrderModeDetails() {
            //获取订单模式详情
            _this
                .$post('/order/getOrderModeDetails', {
                    order_mode_code: _this.data,
                    city_code: JSON.parse(localStorage.getItem('login')).city.city_code
                })
                .then((res) => {
                    _this.loading = false;
                    _this.submit_data.name = res.data.name; // 模式名称

                    // _this.submit_data.kilometer_mode_deduction_type = res.data.kilometer_mode_deduction_type.val;
                    _this.submit_data.scan_appoint_order = res.data.scan_appoint_order;

                    _this.submit_data.check_password = res.data.check_password.val;

                    _this.submit_data.trip_start_upload_status = res.data.trip_start_upload_status;

                    _this.submit_data.trip_end_upload_status = res.data.trip_end_upload_status;

                    _this.spare_data = res.data.synchronization;

                    _this.submit_data.wait_mode = res.data.wait_mode.val;
                    _this.submit_data.circle_mode = res.data.circle_mode.val;

                    _this.submit_data.status = res.data.status.val;

                    _this.submit_data.send_plate = res.data.send_plate.val;
                    _this.submit_data.not_income_wallet = res.data.not_income_wallet.val;

                    _this.submit_data.partner_mode = res.data.partner_mode.val;

                    _this.submit_data.is_sleet = res.data.is_sleet.val;

                    _this.submit_data.kilometer_mode_deduction = res.data.kilometer_mode_deduction;
                    _this.submit_data.kilometer_mode_deduction_ratio = res.data.kilometer_mode_deduction_ratio;

                    _this.init_time = res.data.synchronization[res.data.synchronization.length - 1].time_end;

                    _this.value_port = res.data.port.alias;

                    _this.submit_data.kilometer_mode = res.data.kilometer_mode.val;
                })
                .catch((err) => {});
        },

        // 删除按钮
        delData(index) {
            // 删除数组中对应index的数据

            _this.spare_data.splice(index, 1);
        },

        // 提交按钮
        drivingModelOnSubmit() {
            // 模式扣款金额为按比例

            // var regPos = /^[1-9]+[0-9]*$/; // 验证正整数正则表达式

            // if (!regPos.test(_this.submit_data.kilometer_mode_deduction)) {
            //     _this.$message.error('模式扣款金额百分比应为正整数');
            //     return;
            // }
            // 模式名称为必填项
            if (_this.submit_data.name == '') {
                this.$message.error('请填写模式名称！');
                return;
            }

            if (_this.spare_data.length == 0) {
                _this.$message.error('请点击右上角按钮添加模式配置!');
                return;
            }

            // 判断第一个开始时间和最后一个结束时间是否一致
            if (_this.spare_data[0].time_start != _this.spare_data[_this.spare_data.length - 1].time_end) {
                _this.$message.error('时间未形成闭环');

                return;
            }

            for (let i = 1; i < _this.spare_data.length; i++) {
                // 判断开始时间和上一个结束时间是否一致
                if (_this.spare_data[i].time_start != _this.spare_data[i - 1].time_end) {
                    _this.$message.error('时间填写有误，必须包含一天所有时间段');
                    return;
                }
            }

            // for (let index = 0; index < _this.spare_data.length; index++) {

            //   delete _this.spare_data[index].out_free_time_mode;

            // }

            // 将json格式数据转换成字符串格式赋值给要提交的对象
            _this.submit_data.synchronization = JSON.stringify(_this.spare_data);

            _this
                .$post(
                    _this.submit_url,
                    _this.submit_data
                    // _this.submit_rules
                )
                .then((res) => {
                    _this.$message.success(res.msg);
                    // 向父组件通讯刷新表格内容
                    _this.$emit('onSubmit');
                    // 关闭对话框
                    _this.closeDialog();
                })
                .catch((err) => {});
        },
        // 为组件嵌套太深，导致无法组件无法刷新   使用@input事件，在输入时进行强制刷新
        onInput() {
            _this.$forceUpdate();
        },
        addKiloStep(index) {
            _this.spare_data[index].kilo_step.push({
                kilo_step_kilometer: '',
                kilo_step_kiloprice: ''
            });
            _this.$forceUpdate();
        },
        subKiloStep(index) {
            _this.spare_data[index].kilo_step.pop();
            _this.$forceUpdate();
        },
        // 一口价（公里/时间选择）change事件
        kiloChange(index) {
            // 如果选择公里模式，把时间模式输入框清空
            if (_this.spare_data[index].kilometer_time_select == '1') {
                _this.spare_data[index].kilo_time = [];
            }

            // 如果选择时间模式，把公里模式输入框清空
            if (_this.spare_data[index].kilometer_time_select == '2') {
                _this.spare_data[index].kilo = [];
            }
        },
        // 添加按钮 一口价
        addKilo(index) {
            // 选择一口价以后，如果一口价（公里/时间选择）选项未进行选择，则提示用户选择
            if (_this.spare_data[index].kilometer_time_select == '') {
                this.$message.error('请选择一口价（公里/时间选择）！');
                return;
            }
            console.log(_this.spare_data, '_this.spare_data==');

            if (_this.spare_data[index].kilo == '') {
                _this.spare_data[index].kilo = [];
            }
            if (_this.spare_data[index].kilo_time == '') {
                _this.spare_data[index].kilo_time = [];
            }

            // if (!Array.isArray(_this.spare_data[index].kilo)) {
            //     _this.spare_data[index].kilo = [];
            // }
            // if (!Array.isArray(_this.spare_data[index].kilo_time)) {
            //     _this.spare_data[index].kilo_time = [];
            // }

            if (_this.spare_data[index].kilometer_time_select == '1') {
                // 如果 一口价（公里/时间选择） 是公里模式;  kilo代表 一口价公里模式收费详情 接口返回的是一个对象
                _this.spare_data[index].kilo.push({
                    kilometer: '',
                    kiloprice: ''
                });
            } else if (_this.spare_data[index].kilometer_time_select == '2') {
                // kilo_time代表一口价时间模式收费详情
                _this.spare_data[index].kilo_time.push({
                    kilotime: '',
                    kilotimeprice: ''
                });
            }
            // 是 ‌Vue.js 中的一个方法，用于强制组件重新渲染，即使没有响应式数据发生变化。
            // ‌通常情况下，Vue.js 会自动跟踪数据的变化并进行重新渲染，但有时候您可能需要手动触发重新渲染，这时可以使用 $forceUpdate() 方法。‌
            // 使用场景 当 Vue 的响应式系统未能自动检测到数据变化时。当需要强制组件重新渲染，而不想等待 Vue 的响应式系统自动处理时
            _this.$forceUpdate();
        },

        // 删除按钮 一口价
        subKilo(index) {
            if (_this.spare_data[index].kilometer_time_select == '1') {
                _this.spare_data[index].kilo.pop();
            } else if (_this.spare_data[index].kilometer_time_select == '2') {
                _this.spare_data[index].kilo_time.pop();
            }
            _this.$forceUpdate();
        },
        kiloStepChange(index) {
            _this.spare_data[index].kilo_step = [
                {
                    kilo_step_kilometer: '',
                    kilo_step_kiloprice: ''
                }
            ];
        },
        // 从admin添加页面复制过来的方法
        //  select(index, val) {
        //         // 当前index下的一口价和特惠短途开关互斥

        //         if (val == 'kilometer_time_mode') {
        //             if (_this.spare_data[index].kilometer_time_select == '1') {
        //                 _this.spare_data[index].kilo = [
        //                     {
        //                         kilometer: '',
        //                         kiloprice: ''
        //                     }
        //                 ];
        //             } else if (_this.spare_data[index].kilometer_time_select == '2'){
        //                 _this.spare_data[index].kilo_time = [
        //                     {
        //                         kilotime: '',
        //                         kilotimeprice: ''
        //                     }
        //                 ];
        //             }

        //             // console.log(_this.spare_data[index]);

        //             if (_this.spare_data[index].kilometer_time_mode == '1') {
        //                 _this.spare_data[index].short_distance_mode = '0';
        //             }

        //             // console.log(_this.spare_data[index]);
        //         } else if (val == 'short_distance') {
        //             if(_this.spare_data[index].kilometer_time_select == '1'){
        //                 _this.spare_data[index].kilo = [];

        //             }else if(_this.spare_data[index].kilometer_time_select == '2'){
        //                 _this.spare_data[index].kilo_time = [];
        //             }

        //             if (_this.spare_data[index].short_distance_mode == '1') {
        //                 _this.spare_data[index].kilometer_time_mode = '0';
        //             }
        //         }
        //     },

        // 一口价 短途特惠 双向收费 开关方法 新写方法
        select(index, val) {
            // 当前index下的一口价和特惠短途开关互斥

            if (val == 'kilometer_time_mode') {
                if (_this.spare_data[index].kilometer_time_select == '1') {
                    _this.spare_data[index].kilo = [
                        {
                            kilometer: '',
                            kiloprice: ''
                        }
                    ];
                } else if (_this.spare_data[index].kilometer_time_select == '2') {
                    _this.spare_data[index].kilo_time = [
                        {
                            kilotime: '',
                            kilotimeprice: ''
                        }
                    ];
                }

                // console.log(_this.spare_data[index]);

                if (_this.spare_data[index].kilometer_time_mode == '1') {
                    // 一口价开关打开
                    _this.spare_data[index].short_distance_mode = '0'; // 关闭短途特惠开关
                    // 短途特惠短途起步价，短途起步公里，短途起步时长输入框 绑定值设置为0
                    _this.spare_data[index].short_starting_price = '0';
                    _this.spare_data[index].short_starting_free_kilometre = '0';
                    _this.spare_data[index].short_starting_free_time = '0';
                }

                // console.log(_this.spare_data[index]);
            } else if (val == 'short_distance') {
                // 点击短途特惠开关
                if (_this.spare_data[index].kilometer_time_select == '1') {
                    _this.spare_data[index].kilo = [];
                } else if (_this.spare_data[index].kilometer_time_select == '2') {
                    _this.spare_data[index].kilo_time = [];
                }

                if (_this.spare_data[index].short_distance_mode == '1') {
                    // 如果短途特惠开关开启
                    _this.spare_data[index].kilometer_time_mode = '0'; // 关闭一口价

                    // 在结构里面显示 短途起步价，短途起步公里，短途起步时长输入框
                } else {
                    // 如果短途特惠开关关闭
                    // 短途起步价，短途起步公里，短途起步时长输入框 绑定值设置为0
                    _this.spare_data[index].short_starting_price = '0';
                    _this.spare_data[index].short_starting_free_kilometre = '0';
                    _this.spare_data[index].short_starting_free_time = '0';
                }
            }
        },

        //添加按钮
        addContent() {
            var obj = {};

            // 遍历获取到的数据，将对象的键存到obj对象中(值为空)
            for (const key in _this.obtain_data) {
                obj[key] = '';
            }

            obj['time_start'] = _this.init_time;
            obj['bad_weather_amount'] = '';
            obj['bad_weather_rate'] = '';
            // 每点击一次在数组中加入一个对象
            _this.spare_data.push(obj);
        },

        timeChange(val, keyData) {
            console.log(val);
            if (keyData == 'time_end') {
                _this.init_time = val;
            }
        },

        // 关闭方法
        closeDialog() {
            _this.loading = true;
            _this.show = false;
            // 下拉搜索城市
            _this.value_city_code = '';

            _this.init_time = '';
            // 下拉选择端口
            _this.value_port = 'all';

            // 下拉搜索状态
            _this.value_status_code = '';
            _this.status_select = [];
            // 管理员列表数据
            // admin_lists= [];

            // 下拉搜索模式
            _this.options_mode_code = [];

            _this.selectPages_data = [];
            //获取到的数据
            _this.obtain_data = [];

            // json格式数据
            _this.spare_data = [];

            _this.mode_options_data = {
                page: 1,
                limit: 5
            };

            // 表单数据
            _this.submit_data = {};
        },

        //搜索的下拉框弹出触发
        // cityVisibleChange(val) {
        //     _this.options_city_code = [];

        //     if (val && _this.options_city_code.length < 1) {
        //         // 请求公司管理接口获取公司唯一编码
        //         _this
        //             .$post('/city/cityLists', _this.city_options_data)
        //             .then((res) => {
        //                 _this.options_city_code = res.data;
        //             })
        //             .catch((err) => {});
        //     }
        // },

        // 选择端口
        portChange(val) {
            _this.submit_data.port = val;
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.box-content {
    background-color: #eee;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
}

.box-time {
    display: flex;
    justify-content: space-around;
    padding: 0 20px;
    box-sizing: border-box;
    margin: 20px 0;
}

.box-body {
    display: flex;
    justify-content: space-around;
    padding: 0 20px;
    box-sizing: border-box;

    flex-wrap: wrap;
}

.box-time .el-form-item {
    width: 40%;
}

.box-time .el-form-item .el-date-editor {
    width: 150px;
}

.el-form-item {
    width: 40%;
}

.form-box .el-form {
    display: flex;
    flex-wrap: wrap;
}
</style>